import { InjectionToken } from '@angular/core';

export const GLOBAL_FILTERS_EDITOR = new InjectionToken<boolean>('Used for indication current WC editor mode (widget / global filters)', {
    factory: () => false,
});
